<template>
    <!-- <div class="custom-confirm-background"></div> -->
    <div class="custom-confirm-alert rounded-md" :class="customClass">
        <div class="p-3" role="dialog" aria-labelledby="modal-title">
            <div class="text-start py-3 px-2">
                {{ message }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { audioBeepSound } from './utils';
import { computed } from 'vue';

// 1. Define Props Interface
interface Props {
    status: "success" | "danger" | "info" | "warning";
    message: string;
}

// Use the interface for defining props
const props = defineProps<Props>();

onMounted(()=>{
    audioBeepSound().play();
})

const customClass = computed(() => {
    switch (props.status) {
        case "success":
            return "bg-green-100 border border-green-300 text-green-800";
        case "danger":
            return "bg-red-100 border border-red-300 text-red-800";
        case "info":
            return "bg-blue-100 border border-blue-300 text-blue-800";
        case "warning":
            return "bg-yellow-100 border border-yellow-300 text-yellow-800";
        default:
            return "";
    }
});
</script>

<style lang="scss" scoped>
@keyframes confirm-animate {
    0%   {margin-top:-200px; opacity:0;}
    100% {margin-top: 0; opacity:1;}
}

@keyframes confirm-animate-background {
    0%   {background: rgba(0, 0, 0, 0)}
    100% {background: rgba(0, 0, 0, 0.08)}
}

/* Add some basic styles for demonstration */

.custom-confirm-alert {
    position: fixed;
    width: 300px;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -30%);
    padding: 0px;
    // background: white;
    // border: 1px solid #ccc;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    animation-name: confirm-animate;
    animation-duration: 0.2s;
    z-index: 99999;
    // text-align: center;

}

#_audio_beep_sound_ {
    display: none;
    opacity: 0;
}
</style>